import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { pageColors } from "../../mock";
import { ArrowLeft } from "lucide-react";

const Us = () => {
  const navigate = useNavigate();
  useEffect(() => { document.title = "TMM|US!"; }, []);
  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="brand-page">
        <button className="feed-back" onClick={() => navigate("/fashion")} data-testid="us-back">
          <ArrowLeft size={16} /> Back to Fashion
        </button>
        <header className="brand-hero-center brand-hero-stack" data-testid="us-hero">
          <img src="/img/usmark.png" alt="Us!" className="brand-hero-mark us" />
          <h1 className="shirt-title" style={{ marginTop: "2rem" }} data-testid="us-coming-soon">COMING SOON</h1>
          <p className="shirt-member-note" style={{ textAlign: "center" }}>Something's brewing. Check back.</p>
        </header>
      </div>
    </>
  );
};

export default Us;
